/*
* Date To String Format
* y: year, M: month, d: day, H: hours, m: minutes, s: seconds, f: miliseconds
*/
export default function DateToFormatString(date, format) {
  const re = new RegExp('([a-zA-Z]).*?(\\1\\1\\1|\\1\\1|\\1|)', 'g');

  const result = format.replace(re, (match, p1) => {
    let item = '';
    switch (p1) {
      case 'y':
        item = date.getFullYear(); // yields year
        break;
      case 'M':
        item = date.getMonth() + 1; // yields month
        break;
      case 'd':
        item = date.getDate(); // yields
        break;
      case 'H':
        item = date.getHours(); // yields hours
        break;
      case 'm':
        item = date.getMinutes(); // yields minutes
        break;
      case 's':
        item = date.getSeconds(); // yields seconds
        break;
      case 'f':
        item = date.getMilliseconds(); // yields miliseconds
        break;
      default:
        break;
    }

    item = item.toString();
    if (item.length > match.length) {
      item = item.substring(0, match.length);
    } else {
      item = item.padStart(match.length, '0');
    }
    return item;
  });

  return result;
}
